var angular = require('angular');
require('angular-ui-router');
require('angular-resource');
require('angular-sanitize');
require('angular-cookies');
require('ngreact');

module.exports = angular.module('am', ['ui.router', 'ngSanitize', 'ngResource', 'ngCookies', 'react']);



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/am.js
 **/